function matchAdapter(symbol, config) {
    const route = config.routes.find(r => r.pattern.test(symbol));
    return route?.adapter ?? config.defaultAdapter;
}
export class MultiSourceDataAdapter {
    config;
    _cache;
    constructor(config) {
        this.config = config;
        this._cache = new Map();
    }
    _resolve(symbol) {
        const cached = this._cache.get(symbol);
        if (cached) {
            return cached;
        }
        const adapter = matchAdapter(symbol, this.config);
        this._cache.set(symbol, adapter);
        return adapter;
    }
    async fetchBarsInRange(symbol, timeframe, from, to, chartId) {
        return this._resolve(symbol).fetchBarsInRange(symbol, timeframe, from, to, chartId);
    }
    async fetchBarsBefore(symbol, timeframe, before, limit, chartId) {
        return this._resolve(symbol).fetchBarsBefore(symbol, timeframe, before, limit, chartId);
    }
    subscribeToBar(symbol, timeframe, onBar) {
        return this._resolve(symbol).subscribeToBar(symbol, timeframe, onBar);
    }
    subscribeToTrades(symbol, onTrade) {
        return this._resolve(symbol).subscribeToTrades(symbol, onTrade);
    }
    subscribeToOrderbook(symbol, onUpdate) {
        return this._resolve(symbol).subscribeToOrderbook(symbol, onUpdate);
    }
    async searchSymbols(query) {
        const adapters = [
            ...this.config.routes.map(r => r.adapter),
            this.config.defaultAdapter,
        ];
        const results = await Promise.all(adapters.map(a => a.searchSymbols(query)));
        const flat = results.flat();
        const seen = new Set();
        return flat.filter(s => {
            if (seen.has(s.symbol))
                return false;
            seen.add(s.symbol);
            return true;
        });
    }
    getLastBackfillCoverage(symbol, timeframe, chartId) {
        if (!symbol)
            return null;
        return this._resolve(symbol).getLastBackfillCoverage?.(symbol, timeframe, chartId) ?? null;
    }
    getLastRangeCoverage(symbol, timeframe, chartId) {
        if (!symbol)
            return null;
        return this._resolve(symbol).getLastRangeCoverage?.(symbol, timeframe, chartId) ?? null;
    }
}
